export default {
  title: "Zhangzhongbao Sales Automation Platform",
  // Avue 内置文案会通过 main.js 的 i18n 钩子取 tip.* 子键（如输入框/下拉框占位符）
  tip: {
    title: "Zhangzhongbao Sales Automation Platform",
    input: "Please input",
    select: "Please select",
  },
  logoutTip: "Exit the system, do you want to continue?",
  submitText: "submit",
  cancelText: "cancel",
  search: "Please input search content",
  menuTip: "none menu list",
  wel: {
    info: "Good morning, Smallwei, Avuex is a framework",
    dept: "a certain technology department",
    team: "Team ranking",
    project: "Project access",
    count: "Item number",
    data: {
      subtitle: "real time",
      column1: "Classified statistics",
      column2: "Annex statistics",
      column3: "Article statistics",
      key1: "C",
      key2: "A",
      key3: "A",
      text1: "Total Record Number of Classifications",
      text2: "Number of attachments Uploaded",
      text3: "Comment frequency",
    },
    data2: {
      column1: "Registration today",
      column2: "Login today",
      column3: "Subscription today",
      column4: "Todays review",
    },
    data3: {
      column1: "Conversion rate（Day 28%）",
      column2: "Attendance rate（Day 11%）",
      column3: "Attendance rate（Day 33%）",
    },
    data4: {
      column1: "Error log",
      column2: "Data display",
      column3: "Privilege management",
      column4: "user management",
    },
    table: {
      rw: "Work Tasks",
      nr: "Work content",
      sj: "Working hours",
    },
  },
  route: {
    info: "info",
    website: "website",
    dashboard: "dashboard",
    tags: "tags",
    store: "store",
    permission: "permission",
    api: "api",
    logs: "logs",
    table: "table",
    form: "form",
    data: "data",
    error: "error",
    test: "test",
  },
  login: {
    title: "Login ",
    info: "Sales Automation Platform",
    tenantId: "Please input tenantId",
    username: "Please input username",
    password: "Please input a password",
    wechat: "Wechat",
    qq: "QQ",
    github: "github",
    gitee: "gitee",
    phone: "Please input a phone",
    code: "Please input a code",
    submit: "Login",
    userLogin: "userLogin",
    phoneLogin: "phoneLogin",
    thirdLogin: "thirdLogin",
    msgText: "send code",
    msgSuccess: "reissued code",
  },
  navbar: {
    info: "info",
    logOut: "logout",
    userinfo: "userinfo",
    dashboard: "dashboard",
    lock: "lock",
    bug: "none bug",
    bugs: "bug",
    screenfullF: "exit screenfull",
    screenfull: "screenfull",
    language: "language",
    theme: "theme",
    color: "color",
  },
  tagsView: {
    menu: "menu",
    closeOthers: "Close Others",
    closeAll: "Close All",
  },
  // avue form (search bar) buttons use form.{emptyBtn|mockBtn|printBtn|submitBtn}
  form: {
    emptyBtn: "Clear",
    mockBtn: "Mock",
    printBtn: "Print",
    submitBtn: "Submit",
  },
  crud: {
    // avue dialog title uses crud.{add|edit|view|copy}Title
    addTitle: "Add",
    editTitle: "Edit",
    viewTitle: "View",
    copyTitle: "Copy",
    filter: "Filter",
    menu: "Operation",
    addBtn: "Add",
    editBtn: "Edit",
    delBtn: "Delete",
    viewBtn: "View",
    searchBtn: "Search",
    emptyBtn: "Reset",
    selectBtn: "Select",
    cancelBtn: "Cancel",
    updateBtn: "Update",
    saveBtn: "Save",
    printBtn: "Print",
    excelBtn: "Export",
    submitBtn: "Submit",
    goTabBtn: "Go to handle",
    title: "Regular Table",
    menuTitle: "Menu",
    name: "Name",
    date: "Date",
    user: "User",
    address: "Address",
    province: "Province",
    city: "City",
    module: "Module",
    moduleName: "Module Name",
    parentId: "Parent Node",
    icon: "Icon",
    sort: "Sort",
    url: "URL",
    params: "Parameters",
    menuType: "Type",
    explain: "Description",
    status: "Status",
    enable: "Enable",
    disable: "Disable",
    clicknum: "Click Count",
    show: "Show",
    hide: "Hide",
  },
};
